import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    QR,
} from 'components/other';

import {
    formatUpiUrl,
} from './helpers/format-upi-url';

import styles from './UpiP2PQr.module.scss';

const UpiP2PQr: FC<IProps> = (props) => {
    const upiUrl = formatUpiUrl(props.detailFields, props.amountKopecks);

    if (!upiUrl) {
        return null;
    }

    return (
        <div className={classNames(styles.upiP2PQr, props.className)}>
            <QR
                className={styles.qr}
                text={upiUrl}
            />
            <div className={styles.subtitle}>
                <div className={styles.line}/>
                <div className={styles.text}>
                    or copy UPI ID manually
                </div>
                <div className={styles.line}/>
            </div>
        </div>
    );
};

export default UpiP2PQr;
